export default {
  name: 'saas',
  title: 'SaaS',
  icon: 'cloud-upload-outlined',
  component: () => import('@/views/saas/SaasView.vue')
}
